<template>
    <v-dialog
        v-model="regDialogShow"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        width="100%"
        content-class="mx-0"
    >
        <v-card>
            <v-toolbar
                flat
                dark
                color="main--yellow"
            >
                <v-spacer></v-spacer>
                <v-btn icon @click="regDialogHide">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-layout justify-center class="form-wrap">
                <v-card outlined class="form-card border-transparent">
                    <h1>{{$t('welcome')}}</h1>
                    <p class="ma-5 text-justify">
                        {{$t('sellerRegWelcomeMessage')}}
                        <a
                            :href="presentationUrl"
                            target="_blank"
                            class="text-decorated-underline"
                            @click="clickPresentation"
                        >
                            {{$t('downloadPresentation')}}
                        </a>
                    </p>
                    <v-row class="justify-center mx-0" v-if="registrationMessage">
                        <v-col cols="12" sm="10">
                            <div class="spacer"></div>
                            <div class="spacer"></div>
                            <div class="spacer"></div>
                            <v-alert type="success">
                                {{ registrationMessage }}
                            </v-alert>
                            <v-card-actions class="justify-center">
                                <v-btn
                                    class="main--yellow white--text"
                                    :to="{name: 'home'}"
                                    @click="regDialogHide"
                                    elevation="0"
                                >
                                    {{ $t('mainPage') }}
                                </v-btn>
                            </v-card-actions>
                        </v-col>
                    </v-row>
                    <v-form
                        v-model="model.valid"
                        v-if="!registrationMessage"
                    >
                        <v-row class="justify-center mx-0" v-if="errorMessages.length">
                            <div class="row-content">
                                <v-alert type="error" v-if="errorMessages.length">
                                    <div v-for="(err, idx) in errorMessages" :key="`error-msg-${idx}`">{{ err }}</div>
                                </v-alert>
                            </div>
                        </v-row>
                        <v-row class="justify-center mx-0">
                            <div class="row-content">
                                <v-text-field
                                    :label="$t('companyName')"
                                    id="cName"
                                    v-model="model.companyName"
                                    :rules="rules.companyName"
                                    color="orange lighten-2"
                                ></v-text-field>
                            </div>
                        </v-row>
                        <v-row class="justify-center mx-0" v-if="!isUserLoggedIn">
                            <div class="row-content">
                                <v-text-field
                                    :label="$t('yourName')"
                                    id="name"
                                    v-model="model.name"
                                    :rules="rules.name"
                                    color="orange lighten-2"
                                ></v-text-field>
                            </div>
                        </v-row>
                        <v-row class="justify-center mx-0" v-if="!isUserLoggedIn">
                            <div class="row-content">
                                <v-text-field
                                    :label="$t('phoneNumber')"
                                    id="phoneNumber"
                                    v-model="model.phoneNumber"
                                    :rules="rules.phone"
                                    v-mask="'+38 (###) ###-####'"
                                    color="orange lighten-2"
                                ></v-text-field>
                            </div>
                        </v-row>
                        <v-row class="justify-center mx-0" v-if="!isUserLoggedIn">
                            <div class="row-content">
                                <v-text-field
                                    label="Email"
                                    v-model="model.email"
                                    required
                                    :rules="rules.email"
                                    color="orange lighten-2"
                                ></v-text-field>
                            </div>
                        </v-row>
                        <v-row class="justify-center mx-0" v-if="!isUserLoggedIn">
                            <div class="row-content">
                                <v-text-field
                                    label="Password"
                                    required
                                    v-model="model.password"
                                    :type="passwordFieldType"
                                    :append-icon="passwordIcon"
                                    v-on:click:append="passwordVisibility"
                                    :rules="rules.password"
                                    color="orange lighten-2"
                                    width="256px"
                                >
                                </v-text-field>
                            </div>
                        </v-row>
                        <v-row class="justify-center mx-0">
                            <div class="row-content">
                                <v-select
                                    :items="referrer_items"
                                    :label="$t('howFindUs')"
                                    v-model="model.referrer_type"
                                    :rules="rules.referrer_type"
                                    color="orange lighten-2"
                                ></v-select>
                            </div>
                        </v-row>
                        <v-row class="justify-center mx-0" v-if="!isUserLoggedIn">
                            <div class="row-content">
                                <v-checkbox
                                    v-model="model.privacy"
                                    :rules="rules.privacy"
                                    color="#F5B821"
                                >
                                    <template v-slot:label>
                                        <div d-flex justify-center>
                                            {{$t('iAgreeWith')}}
                                            <router-link
                                                to="/info/politika-konfidentsialnosti"
                                                class="text-underline"
                                                target="_blank"
                                            >
                                                {{$t('withPrivacyPolicy') }}
                                            </router-link>
                                            {{$t('and')}}
                                            <router-link to="/info/usloviya-polzovaniya" class="text-underline"
                                                         target="_blank">{{$t('withUserAgreement') }}
                                            </router-link>
                                        </div>
                                    </template>
                                </v-checkbox>
                            </div>
                        </v-row>
                        <v-row class="justify-center mx-0">
                            <div class="row-content">
                                <v-btn
                                    width="100%"
                                    class="main--yellow white--text"
                                    :disabled="!model.valid"
                                    @click="sendData"
                                    elevation="0"
                                >
                                    {{ $t('register') }}
                                </v-btn>
                            </div>
                        </v-row>
                    </v-form>
                </v-card>

            </v-layout>
        </v-card>
    </v-dialog>
</template>

<script>
    import AuthService from "../../services/api/AuthService";
    import ProfileService from "../../services/api/ProfileService";
    import StatService from "../../services/api/StatService"
    import Auth from "../../mixins/Auth";
    import AppVariables from "../../mixins/AppVariables";
    import ProfileUpdate from '../../mixins/ProfileUpdate';


    export default {
        name: "SellerRegistration",
        mixins: [
            Auth, ProfileUpdate, AppVariables,
        ],
        data() {
            return {
                errorMessages: [],
                isPasswordVisible: false,
                model: {
                    companyName: '',
                    name: '',
                    email: '',
                    password: '',
                    phoneNumber: '',
                    referrer_type: '',
                    privacy: null,
                    valid: false,
                    enter: null,
                },
                registrationMessage: '',
                referrer_items: [
                        {value: 1, text: 'Google'},
                        {value: 2, text: 'Facebook'},
                        {value: 3, text: this.$t('byRecommendation')},
                        {value: 4, text: this.$t('agrolinkManager')}
                    ],
                rules: {
                    companyName: [
                        v => !!v || this.$t('requiredField')
                    ],
                    email: [
                        v => !!v || this.$t('emailRequired'),
                        v => /.+@.+/.test(v) || this.$t('emailInvalid'),
                    ],
                    name: [
                        v => !!v || this.$t('requiredField')
                    ],
                    password: [
                        v => !!v || this.$t('passwordRequired')
                    ],
                    privacy: [
                        v => !!v || this.$t('privacyAccept')
                    ],
                    phone: [
                        v => !!v || this.$t('requiredField')
                    ],
                    referrer_type: [
                        v => !!v || this.$t('chooseOneOption')
                    ]
                }

            }
        },
        computed: {
            passwordFieldType() {
                return this.isPasswordVisible ? 'text' : 'password';
            },
            passwordIcon() {
                return this.isPasswordVisible ? 'mdi-eye-off' : 'mdi-eye';
            },
            regDialogShow: {
                get() {
                    return this.$store.getters.showRegistrationDialog;
                },
                set() {
                    this.$store.commit('sellerRegDialogHide');
                }
            },
            presentationUrl() {
                return this.getCdnPath() + '/presentations/sellers_presentation.pdf';
            }
        },
        methods: {
            clickPresentation(){
                StatService.presentationCountRegister()
                    .then(res => {
                        console.log(res.data);
                    })
                    .catch(err => {
                        console.log(err);
                    });
                return true;
            },
            sendData() {
                if(this.isUserLoggedIn){
                    this.updateToSeller();
                } else {
                    this.registerSeller();
                }

            },
            handleData(){
                const credentials = {
                    companyName: this.model.companyName,
                    refer_type: this.model.referrer_type,
                };

                if(!this.isUserLoggedIn) {
                    credentials.email = this.model.email
                    credentials.name = this.model.name;
                    credentials.phone = this.model.phoneNumber;
                    credentials.password = this.model.password;
                    credentials.c_password = this.model.password;
                    credentials.type = 'seller';
                }

                return credentials
            },
            registerSeller() {

                const credentials = this.handleData();

                AuthService.register(credentials)
                    .then(res => {
                        if (res.data.error) {
                            this.handleErrors(res.data.error);
                        } else {
                            this.errorMessages = [];
                            if(res.data.message == 'success'){
                                this.registrationMessage = this.$t('thankYouForSellerRegistration');
                            }
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            updateToSeller(){
                const credentials = this.handleData();

                ProfileService.changeRole(credentials).then(res => {
                    if (res.data.error) {
                        this.handleErrors(res.data.error);
                    } else {
                        this.errorMessages = [];
                        if(res.data.message == 'success'){
                            this.registrationMessage = this.$t('thankYouForSellerRegistration');
                        }
                    }
                })
                    .catch(err => {
                        console.log(err);
                    });
            },
            handleErrors(errors) {
                this.errorMessages = [];

                for (let i in errors) {
                    this.errorMessages.push(errors[i][0]);
                }

                setTimeout(() => {
                    this.errorMessages = [];
                }, 5000);
            },
            passwordVisibility() {
                this.isPasswordVisible = !this.isPasswordVisible
            },
            regDialogHide() {
                this.$store.commit('sellerRegDialogHide');
                this.clearData()
            },
            clearData() {
                this.registrationMessage = '';
                this.model.companyName = '';
                this.model.name = '';
                this.model.email = '';
                this.model.password = '';
                this.model.phoneNumber = '';
                this.model.referrer_type = '';
                this.model.privacy = null;
            }
        },
    }
</script>

<style scoped>

</style>
